<script>
import ContactTopInfo from "@js/components/Sections/Contacts/Components/ContactTopInfo.vue";
import ContactSocialsList from "@js/components/Sections/Contacts/Components/ContactSocialsList.vue";
import ContactTopForm from "@js/components/Sections/Callback/ContactTopForm.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

export default {
    name: "ContactsTopComponent",
    components: {Breadcrumbs, ContactTopForm, ContactSocialsList, ContactTopInfo}
}
</script>

<template>
    <div
        class="relative ling-bg h-full flex justify-center md:items-center items-start text-center bg-[url('@img/backgrounds/contacts/test.png')] lg:bg-[url('@img/backgrounds/contacts/test.png')] bg-no-repeat bg-cover bg-bottom bg-img pt-10 mb-10">
        <div class="container grid grid-cols-1 md:grid-cols-2 gap-10">
            <div class="text-left">
                <Breadcrumbs class="mb-2"/>
                <ContactTopInfo/>
                <div>
                    <p class="text-2xl text-white font-bold mb-2">
                        Не хотите звонить? Напишите!
                    </p>
                    <p class="text-md text-white mb-5">
                        Все способы связаться с нами онлайн
                    </p>
                   <ContactSocialsList :darker="true"/>
                </div>
            </div>
            <ContactTopForm/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
